if (!customElements.get('sh-shipping-protection')) {
  customElements.define('sh-shipping-protection', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('input').addEventListener('change', () => this.updateProtection());
    }
    async updateProtection() {
      const input = this.querySelector('input');
      const error = this.querySelector('[role="alert"]');
      const wanted = input.checked;
      input.disabled = true;
      error.hidden = true;
      try {
        const cartResponse = await fetch(this.dataset.cartUrl, {headers: {'Accept': 'application/json'}});
        if (!cartResponse.ok) throw new Error(this.dataset.error);
        const cart = await cartResponse.json();
        const item = cart.items.find(line => String(line.variant_id) === this.dataset.variant);
        let response;
        if (wanted && !item) {
          response = await fetch(this.dataset.addUrl, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: [{id: Number(this.dataset.variant), quantity: 1}]})});
        } else if (item && (!wanted || item.quantity !== 1)) {
          response = await fetch(this.dataset.changeUrl, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({id: item.key, quantity: wanted ? 1 : 0})});
        }
        if (response && !response.ok) throw new Error(this.dataset.error);
        window.location.reload();
      } catch (failure) {
        input.checked = !wanted;
        input.disabled = false;
        error.textContent = this.dataset.error;
        error.hidden = false;
      }
    }
  });
}
